import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { IKeyword } from '../models/IKeyword';
import IKeywordSearchDropdownProps from '../models/IKeywordSearchDropdownProps';
import keywordsData from '../assets/keywords.json';

const KeywordSearchDropdown: React.FC<IKeywordSearchDropdownProps> = ({
  getSelectedKeywords,
  label,
}) => {
  const [keywords, setKeywords] = useState<IKeyword[]>([]);
  const [selectedKeywords, setSelectedKeywords] = useState<IKeyword[]>([]);

  useEffect(() => {
    const validKeywords = keywordsData.filter(
      (keyword): keyword is IKeyword => typeof keyword.title === 'string'
    );
    setKeywords(validKeywords);
    console.log('Keywords Data:', validKeywords);
  }, []);

  const handleKeywordChange = (
    _: React.ChangeEvent<unknown>,
    value: IKeyword[]
  ) => {
    setSelectedKeywords(value);
    getSelectedKeywords(value);
  };

  const filterOptions = (
    options: IKeyword[],
    { inputValue }: { inputValue: string }
  ) => {
    return options
      .filter((option) =>
        option.title.toLowerCase().startsWith(inputValue.toLowerCase())
      )
      .slice(0, 200);
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <Autocomplete
        multiple
        options={keywords}
        getOptionLabel={(option) => option.title}
        value={selectedKeywords}
        onChange={handleKeywordChange}
        filterOptions={filterOptions}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            label={label}
            placeholder='Search and select research interests'
            helperText='Please select all research interests - These will automatically be added to your Athena account'
          />
        )}
      />
    </div>
  );
};

export default KeywordSearchDropdown;
